import script from "./StoreDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./StoreDetail.vue?vue&type=script&lang=ts&setup=true"

import "./StoreDetail.vue?vue&type=style&index=0&id=5a73cf8f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a73cf8f"]])

export default __exports__